import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_SALES_ARGUMENT } from "../sales-argument.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateSalesArgumentInput } from "../../../__generated__/globalTypes";
import {
  UpdateSalesArgumentMutation,
  UpdateSalesArgumentMutationVariables,
} from "../../../__generated__/UpdateSalesArgumentMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateSalesArgument = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateSalesArgumentInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateSalesArgumentMutation,
    UpdateSalesArgumentMutationVariables
  >(UPDATE_SALES_ARGUMENT, {
    refetchQueries: ["SalesArgumentsQuery", "SalesArgumentQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateSalesArgument?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateSalesArgument?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
